import {
  type LucideIcon,
  FileEdit,
  Mail,
  ListTodo,
  FileText,
  ClipboardList,
  ListCheck,
  Mails,
  FileStack,
  Bubbles,
  MessageCircleMore,
  MessageCircleOff,
  Users,
  UserCog,
  User,
  Wifi,
  Archive,
  LayoutDashboard,
  CheckSquare,
  MessageSquare,
} from 'lucide-react'

export interface TabConfig {
  value: string
  label: string
  icon: LucideIcon
}

// Home Tabs
export const homeProjectTabs: TabConfig[] = [
  { value: 'my-projects', label: 'Active Projects', icon: ClipboardList },
  { value: 'my-drafts', label: 'Draft Projects', icon: FileEdit },
]

export const homeTaskTabs: TabConfig[] = [
  { value: 'assigned', label: 'Assigned Tasks', icon: ListTodo },
  { value: 'drafts', label: 'Draft Tasks', icon: FileEdit },
]

export const homeMessageTabs: TabConfig[] = [
  { value: 'unread', label: 'Unread Messages', icon: Mail },
  { value: 'drafts', label: 'Draft Messages', icon: FileEdit },
]

export const homeCollaboratorTabs: TabConfig[] = [
  { value: 'online', label: 'Online', icon: Bubbles },
  { value: 'ready-to-chat', label: 'Ready to Chat', icon: MessageCircleMore },
  { value: 'deep-work', label: 'In Deep Work', icon: MessageCircleOff },
]

// Projects Page Tabs
export const projectsPageTabs: TabConfig[] = [
  { value: 'my-incomplete', label: 'My Incomplete Projects', icon: ClipboardList },
  { value: 'all-incomplete', label: 'All Incomplete Projects', icon: ClipboardList },
  { value: 'my-drafts', label: 'Draft Projects', icon: FileEdit },
]

// Tasks Page Tabs
export const tasksPageTabs: TabConfig[] = [
  { value: 'my-assigned', label: 'My Tasks', icon: ListCheck },
  { value: 'my-associated', label: 'Collaborative Tasks', icon: ListCheck },
  { value: 'all', label: 'All Tasks', icon: ListCheck },
  { value: 'my-drafts', label: 'Draft Tasks', icon: FileEdit },
]

// Messages Page Tabs
export const messagesPageTabs: TabConfig[] = [
  { value: 'unread', label: 'Unread Messages', icon: Mail },
  { value: 'open-projects', label: 'Ongoing Work Messages', icon: Mails },
  { value: 'all', label: 'All Messages', icon: Mails },
  { value: 'drafts', label: 'Draft Messages', icon: FileEdit },
  { value: 'archived', label: 'Archived Messages', icon: Archive },
]

// Documents Page Tabs
export const documentsPageTabs: TabConfig[] = [
  { value: 'my-documents', label: 'My Documents', icon: FileText },
  { value: 'ongoing-work', label: 'Ongoing Work Documents', icon: FileText },
  { value: 'all-documents', label: 'All Documents', icon: FileStack },
]

// Project Detail Page Tabs
export const projectDetailTabs: TabConfig[] = [
  { value: 'tasks', label: 'Tasks', icon: ListTodo },
  { value: 'messages', label: 'Messages', icon: Mail },
  { value: 'documents', label: 'Documents', icon: FileText },
]

// Workspace Detail Page Tabs
export const workspaceDetailTabs: TabConfig[] = [
  { value: 'home', label: 'Home', icon: LayoutDashboard },
  { value: 'tasks', label: 'Tasks', icon: CheckSquare },
  { value: 'projects', label: 'Projects', icon: ClipboardList },
  { value: 'messages', label: 'Messages', icon: MessageSquare },
  { value: 'documents', label: 'Documents', icon: FileText },
]

// Workspace Detail Projects Tabs
export const workspaceProjectsTabs: TabConfig[] = [
  { value: 'active', label: 'Active', icon: ClipboardList },
  { value: 'completed', label: 'Completed', icon: CheckSquare },
  { value: 'draft', label: 'My Drafts', icon: FileEdit },
]

// Workspace Detail Tasks Tabs
export const workspaceTasksTabs: TabConfig[] = [
  { value: 'my', label: 'My Tasks', icon: ListCheck },
  { value: 'collaborative', label: 'Collaborative', icon: ListCheck },
  { value: 'all', label: 'All Tasks', icon: ListCheck },
  { value: 'draft', label: 'My Drafts', icon: FileEdit },
]

// Workspace Detail Messages Tabs
export const workspaceMessagesTabs: TabConfig[] = [
  { value: 'all', label: 'All Messages', icon: MessageSquare },
  { value: 'workspace', label: 'Workspace', icon: MessageSquare },
  { value: 'work', label: 'Work', icon: Mails },
  { value: 'draft', label: 'My Drafts', icon: FileEdit },
]

// Users Page Tabs
export const usersPageTabs: TabConfig[] = [
  { value: 'all-users', label: 'All Users', icon: Users },
  { value: 'admins', label: 'Admins', icon: UserCog },
  { value: 'members', label: 'Members', icon: User },
  { value: 'online', label: 'Online', icon: Wifi },
]
